import {
  filter,
  includes,
  isObject,
  values as objectValues,
  has,
  partial,
  every,
  isArray,
} from 'lodash';

import { isConsumerFieldValueEmpty } from '../../../lib/consumer-fields/validation-helper';

export default (values, props) => {
  const requiredFields = filter(props.consumerFieldSchemas, { required: true });
  const errors = {};

  requiredFields.forEach((field) => {
    const value = values[field.name];
    if (isConsumerFieldValueEmpty(value)) {
      errors[field.name] = 'This field is required';
      return;
    }

    if (isObject(value) && !value._isAMomentObject && !isArray(value)) {
      const keys = ['streetAddress', 'city', 'state', 'postalCode', 'country'];

      const values = objectValues(value);
      if (includes(values, undefined) || includes(values, null) || includes(values, "")) {
        errors[field.name] = 'This field is required';
      }

      if (!every(keys, partial(has, value))) {
        errors[field.name] = 'This field is required';
      }
    }

    if (isArray(value) && value.length === 0) {
      errors[field.name] = 'This field is required';
    }
  });


  return errors;
};



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-consumer-fields/validate.js